'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listenForPostMessage = exports.showPopup = exports.getConnectUrl = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _client = require('../client');

var _params = require('../params');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getConnectUrl = exports.getConnectUrl = function getConnectUrl(_ref) {
  var clientId = _ref.clientId,
      email = _ref.email,
      forceSignUp = _ref.forceSignUp,
      homeUrl = _ref.homeUrl,
      redirectUri = _ref.redirectUri,
      oauthParams = _ref.oauthParams;

  var hasParams = email || oauthParams;
  var optionsKey = forceSignUp ? 'encodedOptionsignup' : 'encodedOptions';
  var encodedParams = {
    client_id: clientId,
    redirect_uri: redirectUri,
    state: homeUrl && 'home=' + homeUrl
  };

  var params = {
    acr_values: hasParams ? optionsKey + ':' + (0, _params.base64EncodeParams)(_extends({
      EmailValue: email
    }, (0, _omit2.default)(oauthParams, forceSignUp ? 'SignInTitle' : 'SignUpTitle'))) : forceSignUp && 'signup:true',
    response_type: 'code',
    scope: 'openid+profile+email+account+fundraise+offline_access'
  };

  var encodedUrlParams = (0, _params.formatUrlParams)(encodedParams, true);
  var urlParams = (0, _params.formatUrlParams)(params);
  var baseURL = (0, _client.getBaseURL)().replace('api', 'identity');

  return baseURL + '/connect/authorize?' + encodedUrlParams + '&' + urlParams;
};

var showPopup = exports.showPopup = function showPopup(_ref2) {
  var _ref2$onClose = _ref2.onClose,
      onClose = _ref2$onClose === undefined ? function () {} : _ref2$onClose,
      _ref2$name = _ref2.name,
      name = _ref2$name === undefined ? 'Authentication' : _ref2$name,
      _ref2$popupWindowFeat = _ref2.popupWindowFeatures,
      popupWindowFeatures = _ref2$popupWindowFeat === undefined ? 'width=600,height=900,status=1' : _ref2$popupWindowFeat,
      url = _ref2.url;

  var popupWindow = window.open(url, name, popupWindowFeatures);

  var popupInterval = setInterval(function () {
    if (popupWindow.closed) {
      clearInterval(popupInterval);
      onClose(popupWindow);
    }
  }, 500);
};

var listenForPostMessage = exports.listenForPostMessage = function listenForPostMessage(_ref3) {
  var _ref3$onSuccess = _ref3.onSuccess,
      onSuccess = _ref3$onSuccess === undefined ? function () {} : _ref3$onSuccess,
      redirectUri = _ref3.redirectUri;

  var validSourceOrigin = redirectUri && new _urlParse2.default(redirectUri).origin;

  var listener = function listener(e) {
    var data = e.data;
    var isValid = e.origin === validSourceOrigin;

    if (isValid) {
      onSuccess(data);
    }
  };

  window.addEventListener('message', listener, false);
};